import { IApiKeysState } from './interfaces';

export const initState: IApiKeysState = {
  apiKeys: [],
  loading: false,
  error: null,
  lastCreatedKey: null,
};
